<div [ngClass]="{'translate-y-0': isVisible, 'translate-y-full': !isVisible}" class="fixed bottom-0 left-0 right-0 z-50 p-4 bg-gradient-to-t from-black bg-turquoise/10 backdrop-blur-md border-t border-white/10 transition-transform duration-500 ease-in-out">
  <div class="flex flex-col items-center gap-3">
    
    <a href="https://pay.dimers.com/b/cNi8wPe0geFngqn5n6gfu05" target="_blank" rel="noopener noreferrer"
      class="rounded-md bg-turquoise px-8 py-2.5 text-sm font-semibold text-black shadow-sm hover:bg-cyan-30f0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-turquoise transition-colors">
      Get AI Picks
    </a>
    
    <app-countdown-timer></app-countdown-timer>

  </div>
</div>